import { render } from "./PurchaseHistory.vue?vue&type=template&id=0272ff18&scoped=true"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js"

import "@/assets/scss/_list-history.scss?vue&type=style&index=0&id=0272ff18&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0272ff18"]])

export default __exports__